import { render, staticRenderFns } from "./ClientPricingManager.vue?vue&type=template&id=51059907"
import script from "./ClientPricingManager.vue?vue&type=script&lang=js"
export * from "./ClientPricingManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports